import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { authAdminLogout } from '../../../redux/actions/adminAuthActions';
import AdminAuthContainer from '../../../containers/AdminAuthContainer';
import { Spinner } from '../../../containers/Spinner';

const mapDispatchToProps = dispatch => ({
  authAdminLogout: () => dispatch(authAdminLogout()),
});

class AdminLogout extends Component {
  componentDidMount() {
    setTimeout(() => {
      this.props.authAdminLogout();
    }, 1618 /* GOLDEN RATIO */);
  }

  render() {
    return (
      <AdminAuthContainer>
        <p className="text-muted text-center">
          <FormattedMessage id="logoutPage.message" />
        </p>
        <Spinner className="d-flex justify-content-center" />
      </AdminAuthContainer>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(AdminLogout);
